module.exports = __webpack_public_path__ + "img/karandashi.d5274e3e.svg";